import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    componentDidMount() {
        this.props.getProducts(this.props.name, this.props.upcs);
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.products != this.props.products) {
            return true;
        }

        return false;
    }

    render({ name, upcs, products }) {
        if (products && products[name]) {
            return (
                <product-carousel name={name} upcs={upcs} ref={el => this.el = el}>
                    {this.renderProducts()}
                    <div className='product-carousel-nav' onClick={this.rotate}>
                        <img
                            data-src='https://gfx.tarot.com/images/home/more-arrow.svg'
                            className='lazyload'
                            height='56'
                            width='30'
                            alt='more-arrow'
                        />
                    </div>
                </product-carousel>
            );
        }

        return <product-carousel name={name} upcs={upcs} />;
    }

    renderProducts = () => {
        return this.props.products[this.props.name].map((product, i) => {
            if (!this.props.mode || (this.props.mode == 'vip-sidebar' && i < 2)) {
                return (
                    <a
                        href={product.product_url.replace('https://www.tarot.com', '')}
                        className='product-carousel-item'
                    >

                        <img
                            data-src={product.catalog_image}
                            alt={product.product_name}
                            height='165'
                            width='165'
                            className='lazyload'
                        />
                        {this.renderPrice(product.price)}
                        <h3>
                            <span>{product.product_name}</span>
                        </h3>
                    </a>
                );
            }

            return null;
        });
    }

    renderPrice = (prices) => {
        let price = 'FREE';

        if (prices.kc) {
            if (prices.kc.current && prices.kc.current > 0) {
                price = `${prices.kc.current} KARMA COINS`;
            }

            return (
                <p>
                    <img
                        alt='Karma Coins'
                        data-src='https://gfx.tarot.com/images/site/tarot/karma-coin-store/coin.svg'
                        className='lazyload'
                        height='12'
                        width='12'
                    />
                    {price}
                </p>
            );
        } else if (prices.usd) {
            if (prices.usd.current && prices.usd.current > 0) {
                price = `$${prices.usd.current.toFixed(2)}`;
            }

            return (<p>{price}</p>);
        }

        return null;
    }

    rotate = () => {
        const first = this.el.querySelector('a.product-carousel-item:first-of-type');
        if (first) {
            first.classList.add('move');
            setTimeout(() => {
                this.el.appendChild(first);
                first.classList.remove('move');
            }, 501);
        }
    }
}

const mapStateToProps = (state) => ({
    products: state['product-carousel'],
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    getProducts: (name, upcs) => dispatch({
        type: 'product-carousel:get-products',
        payload: {
            name: name,
            upcs: upcs,
        },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
